<template>
  <div id="sidebar" class="flex center">
    <img class="logo" src="@/assets/images/logo_white.png" />
  </div>
</template>

<script>
export default {
  name: 'LoggedOutSidebar'
}
</script>

<style scoped lang="scss">
@import  '@/assets/styles/constants.scss';

#sidebar {
  background-color: $blue;
  width: 40%;
  height: 100vh;
  float: left;
}

.logo {
  width: 65%;
}

@media screen and (max-width: 480px) {
  #sidebar{
    background-color: #33A1C2;
    width: 100%;
    height: 25vh;
  }
}
</style>
